export const formatTime = (time) =>
  (time - (time %= 60)) / 60 + (time > 9 ? ':' : ':0') + time;
